enum Actions {
    fetchCardInfo,
    fetchCardInfoComplete
}

export default Actions